import { render, staticRenderFns } from "./CalculateProductionKgh.vue?vue&type=template&id=913b3886&"
import script from "./CalculateProductionKgh.vue?vue&type=script&lang=js&"
export * from "./CalculateProductionKgh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports